import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listagem-licencas',
  templateUrl: './listagem-licencas.component.html',
  styleUrls: ['./listagem-licencas.component.scss'],
})
export class ListagemLicencasComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
